<template>
    <div class="layout-page" :class="{'layout-page__show-nav': showNav}">
        <div class="layout-page--content">
            <div class="layout-page--header" v-if="$scopedSlots.header">
                <slot name="header"/>
            </div>

            <slot/>
        </div>

        <div class="layout-page--sidebar">
            <div class="layout-page--sidebar--inner" v-if="$scopedSlots.sidebar">
                <slot name="sidebar"/>
            </div>
        </div>
        
        <sticky v-if="showNav" class="layout-page--nav" full-width>
            <router-link v-for="(item, index) of navItems" :key="index" :to="{name: item.route}" class="layout-page--nav-icon">
                <icon :name="item.icon"/>
            </router-link>
        </sticky>
    </div>
</template>

<style lang="scss">
    .layout-page {
        display: flex;
        width: 100%;
    }
    .layout-page--content {
        min-width: 0;
        flex-grow: 1;
        padding-right: $spacer-2;
    }
    .layout-page--header {
        margin-bottom: $spacer-2;
    }
    .layout-page--sidebar {
        width: $layout-sidebar-width;
        flex-shrink: 0;
    }
    .layout-page--nav {
        display: flex;
        justify-content: space-around;
        align-items: center;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60px;
        background-color: $white;
        box-shadow: 0 -1px 3px rgba($black, .15);
    }
    .layout-page--nav-icon {
        color: $dark-50;
        font-size: 28px;
        &:hover {
            color: $dark-50;
        }
        &.router-link-exact-active {
            color: $dark-red;
        }
    }

    @include media-breakpoint-down("md") {
        .layout-page { 
            flex-direction: column;
        }
        .ie11 .layout-page {
            padding-right: 0;
        }
        .layout-page--content {
            width: 100%;
            padding-right: 0;
        }
        .layout-page--header {
            width: 100%;
        }
        .layout-page--sidebar {
            width: 100%;
            margin-top: $spacer-2;
        }
        .layout-page--sidebar,
        .layout-page--content {
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;
        }
        .layout-page__show-nav {
            padding-bottom: 60px;
        }
    }
    @include media-breakpoint-up('lg') {
        .layout-page--nav {
            display: none;
        }
    }
</style>

<script>
    export default {
        props: {
            showNav: {type: Boolean, default: false},
        },

        computed: {
            navItems() {
                return [
                    {icon: 'home', route: 'community_home'},
                    {icon: 'calendar', route: 'community_event_overview'},
                    {icon: 'account-group', route: 'community_group_overview'},
                    {icon: 'magnify', route: 'community_search'},
                ];
            },
        },
    };
</script>
